import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import '../../../icons/ActivityIcon.js';
import { AgeIcon } from '../../../icons/AgeIcon.js';
import '../../../icons/ArrowDownV2.js';
import '../../../icons/ArrowDownV3.js';
import '../../../icons/ArrowDown.js';
import '../../../icons/ArrowLeftBig.js';
import '../../../icons/ArrowLeft.js';
import '../../../icons/ArrowLeft2.js';
import '../../../icons/ArrowsDown.js';
import '../../../icons/ArrowsUp.js';
import '../../../icons/ArrowUpRightIcon.js';
import '../../../icons/Baccarat.js';
import '../../../icons/BlackJack.js';
import '../../../icons/BookIcon.js';
import '../../../icons/Calendar.js';
import '../../../icons/Carts.js';
import '../../../icons/ChartIcon.js';
import '../../../icons/ChainIcon.js';
import '../../../icons/CheckIcon2.js';
import '../../../icons/CheckIcon.js';
import '../../../icons/Checks.js';
import '../../../icons/ChevronDown.js';
import '../../../icons/Clock.js';
import '../../../icons/Close.js';
import '../../../icons/CoinsIcon.js';
import '../../../icons/Coins.js';
import '../../../icons/CopyIconDouble.js';
import '../../../icons/CopyIconFill.js';
import '../../../icons/Crown.js';
import '../../../icons/CryptoCurrency.js';
import '../../../icons/DiscordIcon.js';
import '../../../icons/DiscordIconV2.js';
import '../../../icons/Dota2.js';
import '../../../icons/Edit.js';
import '../../../icons/ExtendIcon.js';
import '../../../icons/EyeOff.js';
import '../../../icons/Eye.js';
import '../../../icons/FacebookIconV2.js';
import '../../../icons/FacebookIcon.js';
import '../../../icons/FiatCurrency.js';
import '../../../icons/FilterIcon.js';
import '../../../icons/GameIcon.js';
import '../../../icons/GameShows.js';
import '../../../icons/Game.js';
import '../../../icons/HeadPhones.js';
import '../../../icons/HomeIcon.js';
import '../../../icons/Horse.js';
import '../../../icons/InfoFill.js';
import '../../../icons/InfoIcon2.js';
import '../../../icons/InfoIcon.js';
import '../../../icons/InfoOutline.js';
import '../../../icons/LevelUp.js';
import '../../../icons/LinkIcon.js';
import '../../../icons/Link.js';
import '../../../icons/LiveCasino.js';
import '../../../icons/LiveIcons2.js';
import '../../../icons/LobbyIconV2.js';
import '../../../icons/LobbyIcon.js';
import '../../../icons/LogoSmallIcon.js';
import '../../../icons/Lock.js';
import '../../../icons/LOL.js';
import '../../../icons/MaxIcon.js';
import '../../../icons/MedalIcon.js';
import '../../../icons/MedalStarIcon.js';
import '../../../icons/MoneyBagIcon.js';
import '../../../icons/MoneyIcon.js';
import '../../../icons/MoneyRecive.js';
import '../../../icons/NewTwitterIcon.js';
import '../../../icons/OriginalsIcon.js';
import '../../../icons/Original.js';
import '../../../icons/PersonIcon.js';
import '../../../icons/PhoneChatIcon.js';
import '../../../icons/PhotoUp.js';
import '../../../icons/PlayIcon.js';
import '../../../icons/PlusIcon.js';
import '../../../icons/RainIcon.js';
import '../../../icons/RankIcon.js';
import '../../../icons/RankinIcon.js';
import '../../../icons/ReferalIcon.js';
import '../../../icons/RefreshIcon.js';
import '../../../icons/Reload.js';
import '../../../icons/Roulette.js';
import '../../../icons/Search2Icon.js';
import '../../../icons/Search.js';
import '../../../icons/SendIcon.js';
import '../../../icons/Settings2.js';
import '../../../icons/SettingsV3.js';
import '../../../icons/Settings.js';
import '../../../icons/SlotsIcon2.js';
import '../../../icons/SlotsIcon.js';
import '../../../icons/SmileIcon.js';
import '../../../icons/SocialsIcon.js';
import '../../../icons/SortIcon.js';
import '../../../icons/SponsorshipIcon.js';
import '../../../icons/StarFill.js';
import '../../../icons/StarCraft.js';
import '../../../icons/StopIcon.js';
import '../../../icons/TableGamesIcon.js';
import '../../../icons/TelegramIcon.js';
import '../../../icons/TelegramIconV2.js';
import '../../../icons/TopPicksIcon.js';
import '../../../icons/Upload.js';
import '../../../icons/UserMoney.js';
import '../../../icons/UsersIconV2.js';
import '../../../icons/UsersIcon.js';
import '../../../icons/VerifiedIcon.js';
import '../../../icons/WalletAddIcon.js';
import '../../../icons/Wallet.js';
import '../../../icons/WarningIcon.js';
import '../../../icons/DeviceDesktop.js';
import '../../../icons/DeviceTablet.js';
import '../../../icons/DevicePhone.js';
import '../../../icons/ClockOrange.js';
import '../../../icons/CalendarOrange.js';
import '../../../icons/OpenLinkIcon.js';
import '../../../icons/FavoriteFill.js';
import '../../../icons/EditorChoiceV2.js';
import { HousebetsLogoIconV2 } from '../../../icons/HousebetsLogoIconV2.js';
import '../../../icons/ListBullet.js';
import '../../../icons/BankIcon.js';
import '../../../icons/ClockOrangeV2.js';
import '../../../icons/CalendarOrangeV2.js';
import '../../../icons/ReferralIconV2.js';
import '../../../icons/MoneyIconV2.js';
import '../../../icons/UsersIconV3.js';
import '../../../icons/InfoFillV2.js';
import '../../../icons/LockOrange.js';
import '../../../icons/LockV2.js';
import '../../../icons/AlertOrange.js';
import '../../../icons/LiveSupportV2.js';
import '../../../icons/Chat.js';
import '../../../icons/CrossCircle.js';
import '../../../icons/LockV3.js';
import '../../../icons/CoinCrypto.js';
import '../../../form/CheckBox/index.js';
import '../../../form/CodeInput/index.js';
import '../../../form/CryptoSelect/index.js';
import '../../../form/FileUploader/index.js';
import '../../../form/FormInput/index.js';
import '../../../form/FormSelect/index.js';
import '../../../form/PhoneInput/index.js';
import '../../../form/RadioButton/index.js';
import '../../../form/Select/index.js';
import { SelectV2 } from '../../../form/SelectV2/index.js';
import '../../../form/SelectV3/index.js';
import '../../../form/SelectV4/index.js';
import '../../../form/Search/Input/index.js';
import '../../../form/Search/NoResults/index.js';
import '../../../form/Switch/index.js';
import '../../../form/DatePickerInput/index.js';
import '../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import '../../../common/GradientWrapper/index.js';
import { Icon } from '../../../common/Icon/index.js';
import '../../../common/LazyImage/index.js';
import '../../../common/NumberFormat/index.js';
import '../../../common/WithCustomScrollbar/index.js';
import { FooterContacts } from '../FooterContacts/index.js';
import { FooterList } from '../FooterList/index.js';
import styles from './index.module.scss.js';

const Footer = ({
  casinoLinks,
  sportsLinks,
  promoLinks,
  supportLinks,
  contactUsInfo,
  copyright = "\xA92023 Housebets ALL RIGHTS RESERVED",
  textMiddle,
  langOptions = [],
  onLangChange,
  selectedLang = "en",
  className,
  style,
  animations = {
    "data-aos": "fade-up-sm",
    "data-aos-delay": "100",
    "data-aos-duration": "1000"
  },
  ...props
}) => {
  const [lang, setLang] = useState("en");
  const langHandler = (value) => {
    setLang(value[0]);
    onLangChange(value[0]);
  };
  useEffect(() => {
    setLang(selectedLang);
  }, [selectedLang]);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ...props,
      ...animations,
      className: cx(styles.box, className),
      style
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.box__inner }, /* @__PURE__ */ React.createElement("div", { className: styles.top }, /* @__PURE__ */ React.createElement("div", { className: styles["logo-wrapper"] }, /* @__PURE__ */ React.createElement(HousebetsLogoIconV2, null)), /* @__PURE__ */ React.createElement("div", { className: styles.selects }, /* @__PURE__ */ React.createElement("div", { className: styles["select-wrapper"] }, /* @__PURE__ */ React.createElement(
      SelectV2,
      {
        style: {
          width: "100%"
        },
        thumbLabel: "",
        formType: true,
        options: langOptions,
        selectedIds: [lang],
        onSelect: langHandler,
        className: cx(styles.select)
      }
    )))), /* @__PURE__ */ React.createElement("div", { className: styles.middle }, /* @__PURE__ */ React.createElement("div", { className: styles.left }, /* @__PURE__ */ React.createElement(
      FooterList,
      {
        casinoLinks,
        sportsLinks,
        promoLinks,
        supportLinks
      }
    )), /* @__PURE__ */ React.createElement("div", { className: styles.right }, /* @__PURE__ */ React.createElement(FooterContacts, { data: contactUsInfo }))), /* @__PURE__ */ React.createElement("div", { className: styles["middle-bottom"] }, /* @__PURE__ */ React.createElement("div", { className: styles["housebets-text"] }, /* @__PURE__ */ React.createElement(Icon, { iconName: "HousebetsLogoIconV2" }), textMiddle?.left), /* @__PURE__ */ React.createElement("div", { className: styles["gcbseal-text"] }, /* @__PURE__ */ React.createElement(
      Link,
      {
        target: "_blank",
        to: textMiddle?.link || "https://cert.gcb.cw/certificate?id=ZXlKcGRpSTZJaXR5WmpnMFdHWXdMM1k0U0dOUk1XMUJhR2REYTJjOVBTSXNJblpoYkhWbElqb2libTh5WnlzNFkzWlhhSGM1ZVhCaVlWcDNVVlZYUVQwOUlpd2liV0ZqSWpvaU1EQXdZamRoTkRKa1pXVTNZalF5TlRFeVpHWTNNelJsT0dKa01USmhZVEJoTW1ReVlqQTVORFF4T1dJeFlqQTNNR0ZoT1RVd1l6UTBaVFprTVRFME1TSXNJblJoWnlJNklpSjk="
      },
      /* @__PURE__ */ React.createElement(Icon, { iconName: "GCBSeal" })
    ), textMiddle?.right)), /* @__PURE__ */ React.createElement("div", { className: styles.bottom }, /* @__PURE__ */ React.createElement("div", { className: styles.copyright }, copyright), /* @__PURE__ */ React.createElement("div", { className: styles.desktop }, /* @__PURE__ */ React.createElement("div", { className: styles["age-icon-wrapper"] }, /* @__PURE__ */ React.createElement(AgeIcon, null)))))
  );
};
Footer.displayName = "FooterComponent.Footer";

export { Footer };
//# sourceMappingURL=index.js.map
